import { Component, OnInit } from '@angular/core';
import { SeoService, UtilsService } from '@geekeno/ngx-website/services';
import * as AOS from 'aos';

@Component({
  selector: 'app-restaurant',
  imports: [],
  templateUrl: './restaurant.component.html',
  styleUrl: './restaurant.component.scss',
})
export class RestaurantComponent implements OnInit {
  constructor(
    seo: SeoService,
    private utilsService: UtilsService,
  ) {
    seo.setSEO({
      title: 'Premier Restaurant: Drinks, Food, & More | The Shore Agonda',
      description:
        "Indulge your senses at our resort's exceptional restaurant, where every meal is a celebration of flavors and a feast for the eyes. Our culinary team is dedicated to providing a remarkable dining experience, blending local influences with international flair.",
    });
  }
  ngOnInit() {
    if (this.utilsService.isPlatformBrowser) {
      AOS.init({ once: true });
    }
  }
}
